import { FaWhatsapp } from "react-icons/fa";

export default function WhatsAppWidget({ phone, message }) {
  const sanitized = phone.replace(/\D/g, '');
  const url = `https://wa.me/${sanitized}?text=${encodeURIComponent(message || '')}`;

  return (
    <a
      href={url}
      target="_blank"
      rel="noreferrer"
      className="whatsapp-widget"
      aria-label="WhatsApp Chat"
    >
      <FaWhatsapp className="whatsapp-icon" />
      <span className="whatsapp-text">Need help? Chat with us</span>
    </a>
  );
}
